import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import HoldActions from 'app/actions/HoldActions';
import { currentAccountSelector } from 'app/selectors/AuthSelector';

const PrintHoldsContainer = loadable(() => import('app/containers/print/PrintHoldsContainer'));

export function PrintHoldsPageRoute() {
  return <PrintHoldsContainer />;
}

function getRouteData({ dispatch, state, params, query }) {
  const account = currentAccountSelector(state);
  const accountId = account && account.get('id');
  if (!accountId) return [];

  return [dispatch(HoldActions.fetchHolds({ accountId, ...params, ...query }))];
}

export default connectRoute(PrintHoldsPageRoute, { getRouteData });
